import React from 'react';
import { Link } from 'gatsby';

const Cta = () => (
  <div className="relative bg-primary">
    <div className="hidden lg:block h-56 md:absolute md:left-0 md:h-full md:w-1/2">
      <img
        className="w-full h-full object-cover"
        src="https://images.pexels.com/photos/6224/hands-people-woman-working.jpg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
        alt="Support team"
      />
    </div>
    <div className="relative max-w-screen-xl mx-auto px-4 py-12 sm:px-6 lg:px-8 ">
      <div className="md:ml-auto md:w-1/2 md:pl-10">
        <h2 className="mt-2 text-white text-3xl lg:text-5xl leading-11 font-extrabold tracking-tight">
          Ready to Expand Your Marketing?
        </h2>
        <p className="pl-4 mt-3 text-lg leading-7 text-white">
          Start here to request your free website audit.
        </p>
        <div className="mt-8">
          <div className="inline-flex w-5/6">
            <Link to="/contact/">
              <p className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-full text-white bg-secondary hover:text-primary hover:bg-primary-lighter focus:outline-none focus:shadow-outline transition duration-500 ease-in-out">
                Get Started
                <svg className="-mr-1 ml-3 h-5 w-5 text-white" fill="fff" viewBox="0 0 320 512">
                  <path
                    fill="#fff"
                    d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                  ></path>
                </svg>
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Cta;
